import React from "react";
import { Xlogo } from "../common/Assetsmanger";
import { Clogo } from "../common/Assetsmanger";
import { Narrow } from "../common/Assetsmanger";
function Aboutcom() {
  return (
    <div className="pad-bottom text-white text-center lg:text-left pad-section" id="targetComponent">
      <div className="flex flex-wrap w-11/12 lg:w-10/12  mx-auto lg:ms-auto justify-start  headexp">
        <div className="about-content pe-0 lg:pe-20">
          <h2 className="font-extrabold about-content-title text-center lg:text-start">
            Hi, <span>I'm Siva Sooriyan.</span>
          </h2>
          <p className="about-content-sub ">
            👨‍💻 I'm a 24-year-old web developer from Chennai, Tamil Nadu, India.
          </p>
          <p className="about-content-sub ">
            {" "}
            Accomplished Web Developer | 3+ Years Mastery in React, Angular, and
            JavaScript | Dedicated to Precision in Crafting Exceptional Digital
            Solutions. I specialize in crafting high-quality solutions using the
            latest technologies. Beyond my core skills, I'm actively exploring
            AI and Web 3.0, reflecting my dedication to staying at the forefront
            of web development.
          </p>
        </div>
      </div>
      <div className="workexperience ">
        <div>
          <h2 className="w-10/12 lg:w-10/12 mx-auto font-bold pad-bottom ">
            Work Experience
          </h2>
        </div>
        <div className="w-11/12 lg:w-10/12 mx-auto">
            <div className="exxompany pb-12 flex flex-col lg:flex-row  items-center gap-4 lg:gap-20">
               <img src={Xlogo} className='w-32 '/>
             <div>
             <h6 >Frontend Developer, January 2022 - Present.</h6>  
               <p>XERAGO EBIZ PVTLTD, Chennai, India.</p>
             </div>
            
             
            </div> 
            <div className="exxompany  flex flex-col lg:flex-row  items-center gap-4 lg:gap-20">
               <img src={Clogo} className='w-32 '/>
             <div>
             <h6 >Web Developer, February 2021 - December, 2021.</h6>  
               <p>Centaur Systems Global, Chennai, India.</p>
             </div>
            
             
            </div>    
        </div>
      </div>
    </div>
  );
}

export default Aboutcom;
